(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["board-reveal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var els = document.querySelectorAll('.board-reveal');
      els.forEach(function (el) {
        if (el.dataset.brInit) return;
        el.dataset.brInit = '1';

        if (!('IntersectionObserver' in window)) {
          el.classList.add('is-in');
          return;
        }
        var io = new IntersectionObserver(
          function (entries, obs) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-in');
                obs.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.15 }
        );
        io.observe(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collab-show-up"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var videos = document.querySelectorAll('.show-up__video');
    if (!videos.length) return;
    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (video) { video.play().catch(function () {}); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.play().catch(function () {});
        } else {
          entry.target.pause();
        }
      });
    }, { threshold: 0.25 });
    videos.forEach(function (video) { observer.observe(video); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["community-reels"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function markPlaying(video) {
      var media = video.closest('.community-reels__media');
      if (media) media.classList.add('community-reels__media--playing');
    }

    function hideBrokenPosters() {
      document.querySelectorAll('.community-reels__poster').forEach(function (img) {
        if (img.dataset.crInit) return;
        img.dataset.crInit = '1';
        function fail() { img.classList.add('community-reels__poster--hidden'); }
        if (img.complete && !img.naturalWidth) fail();
        img.addEventListener('error', fail);
      });
    }

    function hideBrokenAvatars() {
      document.querySelectorAll('.community-reels__avatar').forEach(function (img) {
        if (img.dataset.crAv) return;
        img.dataset.crAv = '1';
        function fail() { img.classList.add('community-reels__avatar--hidden'); }
        if (img.complete && !img.naturalWidth) fail();
        img.addEventListener('error', fail);
      });
    }

    function playInView(video) {
      if (!video.src && video.dataset.src) video.src = video.dataset.src;
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }

    function init() {
      hideBrokenPosters();
      hideBrokenAvatars();
      var videos = document.querySelectorAll('.community-reels__video[data-src]');
      if (!videos.length) return;

      if (!('IntersectionObserver' in window)) {
        videos.forEach(function (v) {
          if (v.dataset.crVid) return;
          v.dataset.crVid = '1';
          v.addEventListener('playing', function () { markPlaying(v); });
          playInView(v);
        });
        return;
      }

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var v = entry.target;
            if (entry.isIntersecting) {
              playInView(v);
            } else if (!v.paused) {
              v.pause();
            }
          });
        },
        { rootMargin: '200px 200px', threshold: 0.2 }
      );

      videos.forEach(function (v) {
        if (v.dataset.crVid) return;
        v.dataset.crVid = '1';
        v.addEventListener('playing', function () { markPlaying(v); });
        io.observe(v);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smoking-pastor-landing"] && !Shopify.designMode) return;
  try {
    
// Count-up + pillar reveal on scroll
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function fmt(n){ return n.toLocaleString('en-US'); }
    function animateCount(el){
      var target = parseInt(el.getAttribute('data-target'), 10) || 0;
      var suffix = el.getAttribute('data-suffix') || '';
      if (reduce){ el.textContent = fmt(target) + suffix; return; }
      var dur = 1600, start = null;
      function step(ts){
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = fmt(Math.floor(eased * target)) + (p === 1 ? suffix : '');
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)){
      document.querySelectorAll('.count').forEach(animateCount);
      document.querySelectorAll('.pi-pillars').forEach(function(p){ p.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        if (e.target.classList.contains('count')) animateCount(e.target);
        else e.target.classList.add('in');
        io.unobserve(e.target);
      });
    }, { threshold: 0.4 });
    document.querySelectorAll('.count, .pi-pillars').forEach(function (el) { io.observe(el); });
  })();

  // ── Buy box: gallery swap · engraving · dynamic donation · AJAX add-to-cart ──
  (function () {
    var box = document.querySelector('.ttb-sp .buybox');
    if (!box) return;
    var form = box.querySelector('.bb-buy');
    var CART = box.getAttribute('data-cart-url') || '/cart';
    var BOARD = Number(form.getAttribute('data-board')) || 34999;
    var ENG = Number(form.getAttribute('data-eng')) || 2500;
    var DISC = 0.10;
    var CODE = 'CAUSE10';
    function money(c) { return '$' + (c / 100).toFixed(2); }
    function set(sel, txt) { var e = form.querySelector(sel); if (e) e.textContent = txt; }

    // gallery thumbnail swap
    box.querySelectorAll('.bb-thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        var main = box.querySelector('#bbMain');
        if (main) main.src = t.getAttribute('data-full');
        box.querySelectorAll('.bb-thumb').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });

    function isEngraved() {
      var c = form.querySelector('input[name="sp-eng"]:checked');
      return !!(c && c.value === 'engraved');
    }

    function recompute() {
      var engraved = isEngraved();
      var base = BOARD + (engraved ? ENG : 0);
      // CAUSE10 discounts the board only — engraving is charged at full price.
      // Use floor to match Shopify's cent-rounding exactly (349.99 × 10% = 34.999 → Shopify charges −$34.99, not −$35.00).
      var disc = Math.floor(BOARD * DISC);
      var pay = base - disc;
      var meals = Math.round((disc / 100) * 25 / 31.5);
      form.querySelectorAll('.eng-opt').forEach(function (l) { l.classList.toggle('is-active', !!l.querySelector('input:checked')); });
      var field = form.querySelector('.eng-field'); if (field) field.hidden = !engraved;
      set('[data-now]', money(pay));
      set('[data-save]', money(disc));
      set('[data-give]', money(disc));
      set('[data-bd-price]', money(BOARD));
      var engrow = form.querySelector('[data-bd-engrow]'); if (engrow) engrow.hidden = !engraved;
      set('[data-bd-eng]', '+' + money(ENG));
      set('[data-bd-disc]', '−' + money(disc));
      set('[data-bd-pay]', money(pay));
      set('[data-bd-donate]', money(disc));
      set('[data-bd-donate2]', money(disc));
      set('[data-bd-donate3]', money(disc));
      set('[data-bd-meals]', meals + ' ready-to-heat meals');
    }
    form.addEventListener('change', function (e) { if (e.target.name === 'sp-eng') recompute(); });

    // add to cart
    var success = form.querySelector('.bb-success');
    var applied = form.querySelector('.bb-applied');
    var addBtn = form.querySelector('[data-add]');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var engraved = isEngraved();
      var input = form.querySelector('.eng-input');
      if (engraved && input && !input.value.trim()) { input.focus(); input.style.borderColor = 'var(--persimmon)'; return; }
      var board = { id: Number(form.getAttribute('data-board-vid')), quantity: 1 };
      if (engraved && input && input.value.trim()) board.properties = { Engraving: input.value.trim() };
      var payload = { items: [board] };
      if (engraved) payload.items.push({ id: Number(form.getAttribute('data-eng-vid')), quantity: 1 });
      var label = addBtn ? addBtn.textContent : '';
      if (addBtn) { addBtn.setAttribute('aria-busy', 'true'); addBtn.textContent = 'Adding…'; }
      fetch(CART + '/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(payload) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        // Put CAUSE10 on the cart itself so it survives a checkout from /cart.
        // Non-fatal: the Checkout button below still carries ?discount=CAUSE10.
        .then(function () {
          return fetch(CART + '/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ discount: CODE }) })
            .catch(function () {});
        })
        .then(function () {
          if (addBtn) { addBtn.removeAttribute('aria-busy'); addBtn.textContent = label; addBtn.hidden = true; }
          if (applied) applied.hidden = true;
          if (success) success.hidden = false;
        })
        .catch(function () { if (addBtn) { addBtn.removeAttribute('aria-busy'); addBtn.textContent = "Couldn't add — try again"; setTimeout(function () { addBtn.textContent = label; }, 2500); } });
    });
    var keep = form.querySelector('[data-bb-keep]');
    if (keep) keep.addEventListener('click', function () {
      if (success) success.hidden = true;
      if (addBtn) addBtn.hidden = false;
      if (applied) applied.hidden = false;
    });

    recompute();
  })();

  /* ── Community reels: lazy-load + play videos only while in view ── */
  (function () {
    function markPlaying(v) {
      var m = v.closest('.sp-reel-media');
      if (m) m.classList.add('sp-reel-media--playing');
    }
    function hideBroken(sel, cls) {
      document.querySelectorAll(sel).forEach(function (img) {
        if (img.dataset.spInit) return; img.dataset.spInit = '1';
        function fail() { img.classList.add(cls); }
        if (img.complete && !img.naturalWidth) fail();
        img.addEventListener('error', fail);
      });
    }
    function play(v) {
      if (!v.src && v.dataset.src) v.src = v.dataset.src;
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    }
    function init() {
      hideBroken('.ttb-sp .sp-reel-poster', 'sp-reel-poster--hidden');
      hideBroken('.ttb-sp .sp-reel-avatar', 'sp-reel-avatar--hidden');
      var vids = document.querySelectorAll('.ttb-sp .sp-reel-video[data-src]');
      if (!vids.length) return;
      if (!('IntersectionObserver' in window)) {
        vids.forEach(function (v) { if (v.dataset.spVid) return; v.dataset.spVid = '1'; v.addEventListener('playing', function () { markPlaying(v); }); play(v); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) play(v); else if (!v.paused) v.pause();
        });
      }, { rootMargin: '200px 200px', threshold: 0.2 });
      vids.forEach(function (v) { if (v.dataset.spVid) return; v.dataset.spVid = '1'; v.addEventListener('playing', function () { markPlaying(v); }); io.observe(v); });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ttb-oil-care"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function mountYouTube(player, start) {
      var id = player.getAttribute('data-video-id');
      if (!id) return;
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?rel=0&playsinline=1&autoplay=1' + (start ? '&start=' + start : '');
      iframe.title = 'Which oil is best for your cutting board? The True Board';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.allowFullscreen = true;
      player.innerHTML = '';
      player.appendChild(iframe);
    }

    function start(player, seconds) {
      if (!player) return;
      var video = player.querySelector('video');
      if (!video) {
        mountYouTube(player, seconds);
        return;
      }
      player.classList.add('is-playing');
      video.controls = true;
      video.muted = false;
      video.defaultMuted = false;
      video.volume = 1;
      var played = video.play();
      if (played && played.catch) played.catch(function () {});
      if (!seconds) return;
      if (video.readyState >= 1) {
        video.currentTime = seconds;
      } else {
        video.addEventListener('loadedmetadata', function () { video.currentTime = seconds; }, { once: true });
      }
    }

    document.addEventListener('click', function (event) {
      var play = event.target.closest('[data-oil-play]');
      if (play) {
        start(play.closest('[data-oil-player]'), 0);
        return;
      }
      var chapter = event.target.closest('[data-oil-seek]');
      if (chapter) {
        var section = chapter.closest('.ttb-oil__video');
        var player = section && section.querySelector('[data-oil-player]');
        start(player, parseInt(chapter.getAttribute('data-oil-seek'), 10) || 0);
        if (player) player.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
